import React, {useState,useEffect} from 'react'
import {sex} from '../constants';
import {FormValidator,Inputs} from 'coaz-ui';
import client from '../client';
import { formatDate } from '../constants'; 

const TransactionFilter = ({params, submitRef,setEnableSubmit}) => {
    const [transactionFilter,setTransactionFilter] = useState({});
    const [readAuthority,setReadAuthority] = useState(false);
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const [message,setMessage] = useState({content:'',success:false});
    const {request,errorMessage} = client;
    const paymentTypes = ['Mobile','Card'];
    const currencies = ['ZMW','USD','GBP','EUR','ZAR']; 
    const statuses = ['SUCCESSFUL','PENDING','FAILED']; 

    const onChange = (e) => {
        if(transactionFilter && setTransactionFilter) {
            const value = e.target.value;
            if(value === '') {
                setTransactionFilter({...transactionFilter, [e.target.name]: null});
            } else {
                setTransactionFilter({...transactionFilter, [e.target.name]: value});
            }
        }
    };

    const onNumber = (e) => {
        const value = e.target.value;
        if(isNaN(value)) {
            return;
        }
        if(value === '' && value) {
          setTransactionFilter({...transactionFilter, [e.target.name]: null});
        } else {
          setTransactionFilter({...transactionFilter, [e.target.name]: value});
        }
    }

    const onDate = (e) => {
        const value = e.target.value;
        setTransactionFilter({...transactionFilter, [e.target.name]: value});
    };

    const submit = () => {
        params && params.setFilter && params.setFilter(transactionFilter);
        return {
            message:"filter",
            success: true
        }
    }

    const inputs = [
        {
            label:'Payment Type',
            type:'select',
            options:() => {
                let options = [<option value={''}>All</option>];
                paymentTypes.map((option,i) => options.push(<option key={i}>{option}</option>));
                return options;
            },
            name:'paymentType', 
            value:transactionFilter && transactionFilter.paymentType?transactionFilter.paymentType:'',
            onChange:(e) => onChange(e)
        },
        {
            label:'Currency',
            type:'select',
            options:() => {
                let options = [<option value={''}>All</option>];
                currencies.map((option,i) => options.push(<option key={i}>{option}</option>));
                return options;
            },
            name:'currency', 
            value:transactionFilter && transactionFilter.currency?transactionFilter.currency:'',
            onChange:(e) => onChange(e)
        },
        {
            label:'Amount',
            type:'number', 
            name:'amount',
            value:transactionFilter && transactionFilter.amount?transactionFilter.amount:'',   
            placeholder:'Enter amount...',
            onChange:(e) => onNumber(e)
        },
        {
            label:'Account Number',
            type:'text',
            name:'accountNumber', 
            value:transactionFilter && transactionFilter.accountNumber?transactionFilter.accountNumber:'',
            placeholder:'Enter account number...',
            onChange:(e) => onChange(e)
        },
        {
            label:'Transaction Id',
            type:'text',
            name:'transactionId', 
            value:transactionFilter && transactionFilter.identifier?transactionFilter.identifier:'',
            placeholder:'Enter transaction Id...',
            onChange:(e) => onChange(e)
        },
        {
            label:'External Id',
            type:'text',
            name:'externalId',
            value:transactionFilter && transactionFilter.referenceId?transactionFilter.referenceId:'',   
            placeholder:'Enter external Id...',
            onChange:(e) => onChange(e)
        },
        {
            label:'From',
            type:'datetime-local',
            name:'from', 
            value:transactionFilter && transactionFilter.from?formatDate(transactionFilter.from,true,true):'',
            placeholder:'From...',
            onChange:(e) => onDate(e)
        },
        {
            label:'To',
            type:'datetime-local',
            name:'to', 
            value:transactionFilter && transactionFilter.to?formatDate(transactionFilter.to,true,true):'',
            placeholder:'To...',
            onChange:(e) => onDate(e)
        },
        {
            label:'Status',
            type:'select',
            options:() => {
                let options = [<option value=''>All</option>];
                statuses.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'status', 
            value:transactionFilter && transactionFilter.status?transactionFilter.status:'',
            placeholder:'Select status...',
            onChange:(e) => onChange(e)
        }
    ]

    useEffect(() => {
        if(!params || !params.filter) return;
        submitRef.current = { submit: submit };
        setEnableSubmit(true);
        setTransactionFilter(params.filter);
    },[]);

  return (
    <FormValidator>
        <div className='flex flex-col w-full p-8 h-fit'>
            <Inputs inputs={inputs} minWidth={minWidth} paddingX={0} spaceX={32} id='filter' setCalcWidth={setInputWidth}/>
        </div>
    </FormValidator>
  )
}

export default TransactionFilter